import './style.scss';
import $ from 'jquery';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

function heroImageFunction() {
	if($(".wp-block-keztablocks-hero-image.has-anim").length) {
		$(".wp-block-keztablocks-hero-image.has-anim").each(function() {
			const self = $(this),
				image = self.find(".wp-block-keztablocks-hero-image__image").eq(0),
				tl = gsap.to(image, {duration: 1, yPercent:-16.6, ease:"none"});
			let posS, posE;

		    if(image.hasClass("parallax-top")) {
		    	posS = 'top +=120';
		    	posE = 'bottom +=120';
		   	} else {
		   		posS = 'top center';
		    	posE = 'bottom center';
		   	}
			const st = ScrollTrigger.create({
				trigger: self,
				start: posS,
				end: posE,
				scrub: 0.3,
    			toggleActions: "play reverse play reverse",
				animation: tl
			});
		    
		});
	}
}

heroImageFunction();
